import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

interface PatientSuccessModalProps {
    open: boolean;
    patientId: string;
    onClose: () => void;
}

export default function PatientSuccessModal({
    open,
    patientId,
    onClose,
}: PatientSuccessModalProps) {
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="success-modal-title"
            aria-describedby="success-modal-desc"
        >
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "white",
                    boxShadow: 24,
                    borderRadius: 3,
                    p: 4,
                    minWidth: 320,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography
                    id="success-modal-title"
                    variant="h5"
                    sx={{
                        color: "#003595",
                        fontWeight: 600,
                        mb: 2,
                    }}
                >
                    Patient Added Successfully!
                </Typography>
                <Typography
                    id="success-modal-desc"
                    variant="body1"
                    sx={{
                        color: "#333",
                        mb: 1,
                        textAlign: "center",
                    }}
                >
                    The patient has been added to your study.
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        color: "#000",
                        mb: 3,
                        textAlign: "center",
                    }}
                >
                    Unique Patient ID: <strong>{patientId}</strong>
                </Typography>
                <Button
                    variant="contained"
                    onClick={onClose}
                    sx={{
                        backgroundColor: "#003595",
                        color: "#fff",
                        borderRadius: 2,
                        fontWeight: 500,
                        textTransform: "uppercase",
                        px: 4,
                        py: 1,
                        fontSize: "1rem",
                        "&:hover": {
                            backgroundColor: "#002566",
                        },
                    }}
                >
                    Close
                </Button>
            </Box>
        </Modal>
    );
}